export const selectBuilderResult = (state) => state.chartBuilder.result;
export const selectBuilderLoading = (state) => state.chartBuilder.loading;
export const selectBuilderError = (state) => state.chartBuilder.error;
export const selectChartBuilder = (state) => state.chartBuilder || {};
export const selectDashboardSettings = (state) => selectChartBuilder(state).settings || null;
export const selectDashboardSettingsLoading = (state) => selectChartBuilder(state).loading || false;
export const selectDashboardDarkMode = (state) => {
  const settings = selectDashboardSettings(state);
  return settings?.darkMode === true;
};
